/* RESPONSIBLE TEAM: team-frontend-tech */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable @intercom/intercom/no-bare-strings */
const NUMERIC_COMPARISONS = {
  comparison: [{
    label: 'greater than',
    value: 'gt'
  }, {
    label: 'less than',
    value: 'lt'
  }, {
    label: 'is',
    value: 'eq'
  }]
};
export default {
  numeric: NUMERIC_COMPARISONS
};